// Bilingual copy for Trom Motors LLC
export const translations = {
  en: {
    nav: {
      about: "About",
      capabilities: "Capabilities",
      fleet: "Fleet",
      contact: "Contact",
      quote: "Request Quote",
    },
    hero: {
      eyebrow: "NAICS 423830 • Industrial Machinery Wholesalers",
      titleLine1: "Heavy Iron.",
      titleLine2: "Global Reach.",
      subtitle:
        "Trom Motors LLC sources, restores and exports premium industrial machinery from Doral, Florida to the world — bulldozers, wheel loaders, bucket trucks, generators and beyond.",
      ctaPrimary: "Request a Quote",
      ctaSecondary: "Call +1 (786) 806-5404",
      stat1: { k: "10K+", v: "Machines Sourced" },
      stat2: { k: "42", v: "Countries Served" },
      stat3: { k: "24/7", v: "Global Logistics" },
    },
    about: {
      label: "Who We Are",
      title: "Built for operators who don't compromise.",
      body:
        "Headquartered in Doral, Florida, Trom Motors is a merchant wholesaler of heavy industrial machinery serving contractors, mining operators, utility crews and municipalities across the Americas, the Caribbean, Africa and the Middle East. Every unit is hand-picked, inspected and prepared for export by a team obsessed with one thing: reliability under load.",
      pill1: "USA Sourced",
      pill2: "Export Ready",
      pill3: "Inspected & Documented",
    },
    capabilities: {
      label: "What We Do",
      title: "One partner. Every asset class.",
      items: [
        {
          n: "01",
          t: "Earthmoving",
          d: "Wheel loaders, bulldozers, excavators, motor graders and articulated haulers from CAT, Komatsu, Kawasaki, John Deere and Volvo.",
        },
        {
          n: "02",
          t: "Utility & Aerial",
          d: "Bucket trucks, digger derricks, crane trucks and service bodies — Altec, Terex, Versalift on Freightliner, International and Chevrolet chassis.",
        },
        {
          n: "03",
          t: "Power Generation",
          d: "Industrial diesel generators, light towers and standby power packages — CAT, Cummins, Kohler, Generac.",
        },
        {
          n: "04",
          t: "Export & Logistics",
          d: "Port-to-port and door-to-door shipping via Port of Miami and Port Everglades. Full documentation, customs, and pre-shipment inspections.",
        },
      ],
    },
    fleet: {
      label: "Fleet In Motion",
      title: "Real machines. Real yard. Ready to ship.",
      cta: "See a machine you like? Talk to us.",
      cards: [
        { t: "Kawasaki 115ZV", d: "Wheel Loader", tag: "Available", desc: "Heavy-duty rock-bucket wheel loader. Cummins power, low hours, ready for aggregate, mining and port operations." },
        { t: "CAT 349F", d: "Hydraulic Excavator", tag: "Available", desc: "49-ton class hydraulic excavator. Long-reach boom, quick-coupler ready — heavy digging, mass excavation and mining." },
        { t: "CAT D6 / D5 Dozer Fleet", d: "Bulldozer Lineup", tag: "Available", desc: "Late-model CAT crawler dozers — B85, D5 LGP, D6. Wide-track configurations for grading, land clearing and fine dozing." },
        { t: "Mack Anthem Day Cabs", d: "Semi Truck Fleet", tag: "Available", desc: "Fleet of clean-title Mack day-cab tractors. Heavy-haul ready, DOT-compliant, ideal for owner-operators and export." },
        { t: "CAT 966M", d: "Wheel Loader • Fork Attach", tag: "Available", desc: "CAT 966M mid-size wheel loader with pallet-fork and grapple attachments. Perfect for lumber, recycling and material yards." },
        { t: "Cummins Industrial Diesel", d: "Standby Generator", tag: "Available", desc: "Industrial Cummins genset on skid-mount frame. Load-tested, service records available, ready for standby and prime power." },
        { t: "CAT D6N XL", d: "Bulldozer", tag: "Reserved", desc: "Legendary Caterpillar crawler dozer with wide track and hydrostatic drive — the workhorse of grading and land clearing." },
        { t: "John Deere 524K", d: "Wheel Loader", tag: "Available", desc: "Mid-size wheel loader with Deere 4045H diesel. Perfect for construction sites, quarries and material handling." },
        { t: "Altec AA55 Bucket Truck", d: "Utility • Freightliner", tag: "Available", desc: "55-ft insulated boom on a Freightliner chassis. Utility, telecom and tree-line ready — inspected and export-prepped." },
        { t: "Altec on Chevrolet C7500", d: "Bucket Truck", tag: "Available", desc: "Chevrolet C7500 with Altec aerial device. Dependable service platform for municipal and contractor fleets." },
        { t: "Cummins QSK60", d: "Industrial Generator", tag: "Inbound", desc: "2 MW class standby diesel generator. Tier-2 emissions, tested under load, documented for international shipping." },
        { t: "Mack RD Fuel Truck", d: "Tanker • Unit 1203", tag: "Available", desc: "Heavy-duty Mack RD-Series tandem-axle fuel/lube truck. On-site refueling for fleets, mines and remote job sites." },
        { t: "Waterous Detroit Diesel Genset", d: "Industrial Generator", tag: "Available", desc: "Skid-mounted Detroit Diesel powered generator with Waterous alternator. Solid workhorse for standby and prime power applications." },
        { t: "Mack Granite Service Truck", d: "Mechanic Truck • Crane", tag: "Available", desc: "Mack Granite with knuckle-boom crane and full service body. Ideal for field service, tire changes and heavy-equipment maintenance." },
        { t: "Roadtec Shuttle Buggy", d: "Asphalt Transfer Vehicle", tag: "Available", desc: "Self-propelled asphalt material transfer vehicle. Keeps pavers running continuously — a must for highway and airport paving crews." },
        { t: "Roadtec RX900", d: "Cold Planer / Milling Machine", tag: "Available", desc: "High-production half-lane cold planer. Precision milling for asphalt rehabilitation on interstates, ports and airfields." },
        { t: "CAT 3512C Sound-Attenuated", d: "Enclosed Diesel Genset", tag: "Available", desc: "Sound-attenuated CAT industrial generator in weatherproof enclosure. Ideal for hospitals, data centers and critical prime-power sites." },
        { t: "CAT 3412 Open Frame", d: "Industrial Generator", tag: "Available", desc: "Open-frame Caterpillar diesel genset with rear-mounted radiator. Rugged prime and standby power for heavy industry and mining." },
        { t: "CAT 3406C R05-8", d: "500 kW Class Genset", tag: "Available", desc: "Skid-mounted CAT 3406C industrial genset. Tested under load with service records — dependable workhorse for standby and prime applications." },
      ],
    },
    trust: {
      items: [
        "NAICS 423830",
        "DORAL • FLORIDA",
        "HEAVY MACHINERY EXPORT",
        "PORT OF MIAMI",
        "INSPECTED & DOCUMENTED",
        "24 / 7 QUOTES",
        "GLOBAL DELIVERY",
      ],
    },
    process: {
      label: "How We Export",
      title: "From auction floor to your yard.",
      body: "A transparent 5-step process. We handle the risk, the paperwork and the logistics — you receive a running, documented machine at your door.",
      steps: [
        {
          n: "01",
          t: "Live Auction",
          d: "We bid on your behalf at Ritchie Bros., IronPlanet and premier US auctions. Our team pre-inspects every lot and sets the ceiling with you before the hammer drops.",
        },
        {
          n: "02",
          t: "Purchase & Inspection",
          d: "Winning lot is paid, titled and moved to our yard. Fluids checked, hours verified, undercarriage photographed. Full report shared with you.",
        },
        {
          n: "03",
          t: "Loading & Containerization",
          d: "Machine is prepped, drained per IMO rules, secured and loaded — into a 40' HC container, RoRo or flat rack — depending on size and destination.",
        },
        {
          n: "04",
          t: "Cross-Country Haul",
          d: "Oversize DOT-permitted lowboys move the unit to the Port of Miami or Port Everglades. GPS tracked, insured and photographed at each checkpoint.",
        },
        {
          n: "05",
          t: "Ocean Freight & Delivery",
          d: "We book vessel, handle export docs, customs and B/L. Machine ships to your port and — if you need — we coordinate inland delivery to your yard.",
        },
      ],
      galleryLabel: "Ocean Freight — In Action",
      galleryTitle: "Real shipments. Real ports.",
      gallery: [
        { t: "M/V Maria Eugenia — River Barge Loading", d: "Excavators secured for river transit to inland ports." },
        { t: "CAT 374DL — Port Loading", d: "49-ton excavator on lowboy alongside container vessel at dawn." },
        { t: "CAT 745 Articulated Truck — Port Lift", d: "Reach stacker positioning a 40-ton hauler for export." },
      ],
    },
    contact: {
      label: "Get In Touch",
      title: "Tell us what you're building.",
      body: "Send an inquiry or call our desk. We reply within one business day with photos, video and freight quotes.",
      address: "8400 NW 33rd Street, Suite 310, Doral, FL 33122, USA",
      form: {
        name: "Your Name",
        company: "Company",
        email: "Email",
        phone: "Phone (optional)",
        interest: "Machinery of Interest",
        message: "Tell us what you need — make, model, quantity, destination.",
        submit: "Send Inquiry",
        sending: "Sending…",
        success: "Inquiry received. We'll be in touch shortly.",
        error: "Something went wrong. Please call +1 (786) 806-5404.",
        required: "Please fill in name, email and message.",
      },
    },
    footer: {
      tagline: "Industrial Machinery & Equipment Wholesalers",
      rights: "All rights reserved.",
      quick: "Quick Links",
      contact: "Contact",
    },
    sticky: {
      call: "Call",
      email: "Email",
    },
  },
  es: {
    nav: {
      about: "Nosotros",
      capabilities: "Servicios",
      fleet: "Flota",
      contact: "Contacto",
      quote: "Solicitar Cotización",
    },
    hero: {
      eyebrow: "NAICS 423830 • Mayoristas de Maquinaria Industrial",
      titleLine1: "Hierro Pesado.",
      titleLine2: "Alcance Global.",
      subtitle:
        "Trom Motors LLC selecciona, restaura y exporta maquinaria industrial premium desde Doral, Florida hacia el mundo — bulldozers, cargadores, camiones grúa, generadores y más.",
      ctaPrimary: "Solicitar Cotización",
      ctaSecondary: "Llamar +1 (786) 806-5404",
      stat1: { k: "10K+", v: "Máquinas Suministradas" },
      stat2: { k: "42", v: "Países Atendidos" },
      stat3: { k: "24/7", v: "Logística Global" },
    },
    about: {
      label: "Quiénes Somos",
      title: "Hecho para operadores que no negocian.",
      body:
        "Con sede en Doral, Florida, Trom Motors es un mayorista de maquinaria industrial pesada que atiende a contratistas, mineros, cuadrillas de servicios y municipios en América, el Caribe, África y Medio Oriente. Cada unidad es seleccionada, inspeccionada y preparada para exportación por un equipo obsesionado con una sola cosa: confiabilidad bajo carga.",
      pill1: "Origen EE.UU.",
      pill2: "Lista para Exportar",
      pill3: "Inspeccionada y Documentada",
    },
    capabilities: {
      label: "Qué Hacemos",
      title: "Un socio. Todos los activos.",
      items: [
        {
          n: "01",
          t: "Movimiento de Tierra",
          d: "Cargadores, bulldozers, excavadoras, motoniveladoras y camiones articulados de CAT, Komatsu, Kawasaki, John Deere y Volvo.",
        },
        {
          n: "02",
          t: "Servicios y Altura",
          d: "Camiones canasta, perforadoras, camiones grúa y carrocerías de servicio — Altec, Terex, Versalift sobre chasis Freightliner, International y Chevrolet.",
        },
        {
          n: "03",
          t: "Generación de Energía",
          d: "Generadores diésel industriales, torres de iluminación y paquetes de respaldo — CAT, Cummins, Kohler, Generac.",
        },
        {
          n: "04",
          t: "Exportación y Logística",
          d: "Envío puerto a puerto y puerta a puerta vía Port of Miami y Port Everglades. Documentación completa, aduana e inspecciones previas.",
        },
      ],
    },
    fleet: {
      label: "Flota en Movimiento",
      title: "Máquinas reales. Patio real. Listas para embarcar.",
      cta: "¿Ves una máquina que te gusta? Habla con nosotros.",
      cards: [
        { t: "Kawasaki 115ZV", d: "Cargador Frontal", tag: "Disponible", desc: "Cargador de servicio pesado con cucharón para roca. Motor Cummins, pocas horas, listo para agregados, minería y operaciones portuarias." },
        { t: "CAT 349F", d: "Excavadora Hidráulica", tag: "Disponible", desc: "Excavadora hidráulica clase 49 toneladas. Pluma de largo alcance, acoplador rápido — excavación pesada, movimiento masivo y minería." },
        { t: "Flota CAT D6 / D5", d: "Bulldozers", tag: "Disponible", desc: "Bulldozers Caterpillar de última generación — B85, D5 LGP, D6. Orugas anchas para nivelación, desmonte y trabajo fino." },
        { t: "Mack Anthem Day Cab", d: "Camiones Semi", tag: "Disponible", desc: "Flota de tractores Mack día cab con título limpio. Listos para carga pesada, cumplimiento DOT, ideales para operadores y exportación." },
        { t: "CAT 966M", d: "Cargador • Uñas para Palet", tag: "Disponible", desc: "Cargador frontal CAT 966M con uñas para palet y garra. Perfecto para maderas, reciclaje y patios de materiales." },
        { t: "Cummins Diésel Industrial", d: "Generador Standby", tag: "Disponible", desc: "Grupo electrógeno Cummins industrial sobre skid. Probado bajo carga, historial disponible, listo para respaldo y potencia primaria." },
        { t: "CAT D6N XL", d: "Bulldozer", tag: "Reservado", desc: "Legendario bulldozer Caterpillar con oruga ancha y tracción hidrostática — el caballo de batalla en nivelación y desmonte." },
        { t: "John Deere 524K", d: "Cargador Frontal", tag: "Disponible", desc: "Cargador de tamaño medio con motor Deere 4045H. Ideal para obras, canteras y manejo de materiales." },
        { t: "Altec AA55 Camión Canasta", d: "Utilitario • Freightliner", tag: "Disponible", desc: "Pluma aislada de 55 pies sobre chasis Freightliner. Listo para servicios públicos, telecom y poda — inspeccionado y preparado para exportar." },
        { t: "Altec sobre Chevrolet C7500", d: "Camión Canasta", tag: "Disponible", desc: "Chevrolet C7500 con equipo aéreo Altec. Plataforma confiable para flotas municipales y contratistas." },
        { t: "Cummins QSK60", d: "Generador Industrial", tag: "En Camino", desc: "Generador diésel clase 2 MW. Emisiones Tier-2, probado bajo carga, documentado para envío internacional." },
        { t: "Mack RD Camión Cisterna", d: "Tanquero • Unidad 1203", tag: "Disponible", desc: "Camión Mack RD tándem para combustible/lubricantes. Reabastecimiento en sitio para flotas, minas y obras remotas." },
        { t: "Waterous Detroit Diesel", d: "Generador Industrial", tag: "Disponible", desc: "Grupo electrógeno sobre skid con motor Detroit Diesel y alternador Waterous. Trabajador confiable para respaldo y potencia primaria." },
        { t: "Mack Granite Camión Taller", d: "Mecánico • Grúa", tag: "Disponible", desc: "Mack Granite con grúa articulada y carrocería de servicio. Ideal para servicio en campo, cambio de neumáticos y mantenimiento pesado." },
        { t: "Roadtec Shuttle Buggy", d: "Transferencia de Asfalto", tag: "Disponible", desc: "Vehículo autopropulsado de transferencia de material asfáltico. Mantiene la pavimentadora en operación continua — clave en carreteras y aeropuertos." },
        { t: "Roadtec RX900", d: "Fresadora de Asfalto", tag: "Disponible", desc: "Fresadora de alta producción media-vía. Fresado de precisión para rehabilitación de asfalto en autopistas, puertos y aeródromos." },
        { t: "CAT 3512C Insonorizado", d: "Generador con Enclosure", tag: "Disponible", desc: "Generador CAT industrial insonorizado en cabina intemperie. Ideal para hospitales, data centers y sitios críticos de potencia primaria." },
        { t: "CAT 3412 Marco Abierto", d: "Generador Industrial", tag: "Disponible", desc: "Grupo electrógeno Caterpillar de marco abierto con radiador trasero. Robusto para respaldo y potencia primaria en industria pesada y minería." },
        { t: "CAT 3406C R05-8", d: "Generador 500 kW", tag: "Disponible", desc: "Genset CAT 3406C sobre skid. Probado bajo carga con historial de servicio — caballo de batalla confiable para respaldo y aplicaciones primarias." },
      ],
    },
    trust: {
      items: [
        "NAICS 423830",
        "DORAL • FLORIDA",
        "EXPORTACIÓN DE MAQUINARIA",
        "PORT OF MIAMI",
        "INSPECCIONADO Y DOCUMENTADO",
        "COTIZACIONES 24 / 7",
        "ENTREGA GLOBAL",
      ],
    },
    process: {
      label: "Cómo Exportamos",
      title: "De la subasta a tu patio.",
      body: "Un proceso transparente en 5 pasos. Nosotros asumimos el riesgo, el papeleo y la logística — tú recibes una máquina funcionando y documentada en tu puerta.",
      steps: [
        {
          n: "01",
          t: "Subasta en Vivo",
          d: "Pujamos por ti en Ritchie Bros., IronPlanet y las principales subastas de EE.UU. Inspeccionamos cada lote y acordamos el tope contigo antes del martillazo.",
        },
        {
          n: "02",
          t: "Compra e Inspección",
          d: "El lote ganado se paga, se titula y se mueve a nuestro patio. Fluidos revisados, horas verificadas, tren de rodaje fotografiado. Reporte completo compartido contigo.",
        },
        {
          n: "03",
          t: "Carga y Contenedor",
          d: "La máquina se prepara, se drena según normas IMO, se asegura y se carga — en contenedor 40' HC, RoRo o flat rack — según tamaño y destino.",
        },
        {
          n: "04",
          t: "Transporte Terrestre",
          d: "Lowboys DOT con permisos de sobredimensión llevan la unidad al Port of Miami o Port Everglades. Con GPS, asegurada y fotografiada en cada punto.",
        },
        {
          n: "05",
          t: "Flete Marítimo y Entrega",
          d: "Reservamos el buque, gestionamos documentos de exportación, aduana y B/L. La máquina llega a tu puerto y — si lo necesitas — coordinamos la entrega hasta tu patio.",
        },
      ],
      galleryLabel: "Flete Marítimo — En Acción",
      galleryTitle: "Envíos reales. Puertos reales.",
      gallery: [
        { t: "M/V María Eugenia — Carga en Barcaza", d: "Excavadoras aseguradas para tránsito fluvial hacia puertos interiores." },
        { t: "CAT 374DL — Carga Portuaria", d: "Excavadora de 49 t sobre lowboy junto al buque contenedor al amanecer." },
        { t: "CAT 745 Camión Articulado — Izaje", d: "Reach stacker posicionando un camión de 40 t para exportación." },
      ],
    },
    contact: {
      label: "Contáctanos",
      title: "Cuéntanos qué estás construyendo.",
      body: "Envía una solicitud o llama a nuestra oficina. Respondemos en un día hábil con fotos, video y cotizaciones de flete.",
      address: "8400 NW 33rd Street, Suite 310, Doral, FL 33122, USA",
      form: {
        name: "Tu Nombre",
        company: "Empresa",
        email: "Correo",
        phone: "Teléfono (opcional)",
        interest: "Maquinaria de Interés",
        message: "Cuéntanos qué necesitas — marca, modelo, cantidad, destino.",
        submit: "Enviar Solicitud",
        sending: "Enviando…",
        success: "Solicitud recibida. Te contactaremos pronto.",
        error: "Ocurrió un error. Por favor llama al +1 (786) 806-5404.",
        required: "Por favor completa nombre, correo y mensaje.",
      },
    },
    footer: {
      tagline: "Mayoristas de Maquinaria y Equipos Industriales",
      rights: "Todos los derechos reservados.",
      quick: "Enlaces Rápidos",
      contact: "Contacto",
    },
    sticky: {
      call: "Llamar",
      email: "Correo",
    },
  },
};
